import {daysUntil, formatDate} from "~/components/data-grid/cells/gridCellFormat";
import {subLine} from "~/components/data-grid/cells/gridCells";

/** Requalification sub-line: the due date, or "requal overdue" once it has passed. */
export function requalLine(requalificationDue: string | null) {
    const days = daysUntil(requalificationDue);
    const overdue = days !== null && days < 0;
    return subLine(
        overdue ? 'requal overdue' : `requal ${formatDate(requalificationDue)}`,
        overdue ? 'error.main' : 'text.secondary',
    );
}
